/*
 * Cleverroute
 * Cleverroute API
 *
 * OpenAPI spec version: 0.0.2
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.36
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {IntermodalRoutingParams} from './IntermodalRoutingParams';
import {MetricParams} from './MetricParams';
import {RoutingParams} from './RoutingParams';
import {TransportSimple} from './TransportSimple';
import {TransportUi} from './TransportUi';

/**
 * The Transport model module.
 * @module model/Transport
 * @version 0.0.2
 */
export class Transport {
  /**
   * Constructs a new <code>Transport</code>.
   * @alias module:model/Transport
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>Transport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Transport} obj Optional instance to populate.
   * @return {module:model/Transport} The populated <code>Transport</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Transport();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('transportType'))
        obj.transportType = ApiClient.convertToType(data['transportType'], 'String');
      if (data.hasOwnProperty('ui'))
        obj.ui = TransportUi.constructFromObject(data['ui']);
      if (data.hasOwnProperty('routingParams'))
        obj.routingParams = RoutingParams.constructFromObject(data['routingParams']);
      if (data.hasOwnProperty('intermodalRoutingParams'))
        obj.intermodalRoutingParams = IntermodalRoutingParams.constructFromObject(data['intermodalRoutingParams']);
      if (data.hasOwnProperty('firstMile'))
        obj.firstMile = TransportSimple.constructFromObject(data['firstMile']);
      if (data.hasOwnProperty('lastMile'))
        obj.lastMile = TransportSimple.constructFromObject(data['lastMile']);
      if (data.hasOwnProperty('metricParams'))
        obj.metricParams = MetricParams.constructFromObject(data['metricParams']);
      if (data.hasOwnProperty('isIntermodal'))
        obj.isIntermodal = ApiClient.convertToType(data['isIntermodal'], 'Boolean');
      if (data.hasOwnProperty('vehicleType'))
        obj.vehicleType = ApiClient.convertToType(data['vehicleType'], 'String');
      if (data.hasOwnProperty('isUsed'))
        obj.isUsed = ApiClient.convertToType(data['isUsed'], 'Boolean');
    }
    return obj;
  }
}

/**
 * unique id of the vehicle like carsharing_regiomboil, bicycle, car, pedelec, e-scooter
 * @member {String} id
 */
Transport.prototype.id = undefined;

/**
 * type of the composition of the transportType like rideAndBikesharing for oepv + bikesharing
 * @member {String} transportType
 */
Transport.prototype.transportType = undefined;

/**
 * @member {module:model/TransportUi} ui
 */
Transport.prototype.ui = undefined;

/**
 * @member {module:model/RoutingParams} routingParams
 */
Transport.prototype.routingParams = undefined;

/**
 * @member {module:model/IntermodalRoutingParams} intermodalRoutingParams
 */
Transport.prototype.intermodalRoutingParams = undefined;

/**
 * @member {module:model/TransportSimple} firstMile
 */
Transport.prototype.firstMile = undefined;

/**
 * @member {module:model/TransportSimple} lastMile
 */
Transport.prototype.lastMile = undefined;

/**
 * @member {module:model/MetricParams} metricParams
 */
Transport.prototype.metricParams = undefined;

/**
 * @member {Boolean} isIntermodal
 */
Transport.prototype.isIntermodal = undefined;

/**
 * 'public' (like train or bus) or 'individual' (like car or bicycle possible 
 * @member {String} vehicleType
 */
Transport.prototype.vehicleType = undefined;

/**
 * whether this transport type is used
 * @member {Boolean} isUsed
 */
Transport.prototype.isUsed = undefined;

